import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  instance = {
    id: "c9737bf1-bb49-4cd5-96f2-0788e97aeb94"
  };

  constructor() { }

  ngOnInit() {
  }

}
